import React from 'react';

export const PrivacyPage: React.FC = () => (
  <main className="kin-page">
    <h1>Privacy</h1>
    <div className="kin-prose">
      <p>
        Photos you restore are private to your account. Originals and outputs are stored in secured
        cloud storage for your library and downloads.
      </p>
      <p>
        <strong>Retention (Alpha):</strong> jobs are marked with an intended retention window
        (approximately 60 days), and you can delete a job anytime from your library. Automatic
        expiration cleanup is not yet fully enforced during Alpha — treat storage as temporary
        development retention while we finish deletion automation.
      </p>
      <p>
        We do not sell your photographs. Model providers process image bytes solely to fulfill your
        restoration request.
      </p>
      <p>
        For privacy questions during Alpha, use the contact channel published on{' '}
        <a href="https://kinvera.io">kinvera.io</a> when available, or reach out through your
        existing Kinvera testing correspondence.
      </p>
    </div>
  </main>
);

export const TermsPage: React.FC = () => (
  <main className="kin-page">
    <h1>Terms</h1>
    <div className="kin-prose">
      <p>
        Kinvera provides AI-assisted photo restoration tools. Results are best-effort archival aids,
        not guaranteed museum scans. You must own or have rights to photos you upload.
      </p>
      <p>
        During Alpha, restorations may be provided without charge for testing. When paid credits are
        introduced, credits will be non-transferable. Failed restorations due to service errors may
        be retried at our discretion.
      </p>
      <p>These terms are a development-stage draft and will be updated before paid launch.</p>
    </div>
  </main>
);
